export default __webpack_public_path__ + "static/image6-4df80b30a9da209e510181c41d56f63b.jpeg";